// Central Calendly configuration.
// TODO: replace CALENDLY_URL with the real link when it's ready.
export const CALENDLY_URL = 'https://calendly.com/bidsignaliq/demo';

/**
 * Opens the Calendly scheduling popup on top of the current page.
 * The visitor never leaves bidsignaliq.com.
 * Falls back to opening the URL in a new tab if the Calendly widget
 * script hasn't loaded yet (rare — the script is async in <head>).
 */
export const openCalendly = () => {
  if (typeof window !== 'undefined' && window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    return false;
  }
  // Graceful fallback while the script is still loading
  window.open(CALENDLY_URL, '_blank', 'noopener,noreferrer');
  return false;
};
